import { useEffect, useState, useContext } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { AuthContext } from "../context/AuthProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";
import renderInputMatchAdornment from "../sections/product/InputMatchAdornment";

const CategorySelector = ({
  value,
  onChange,
  disabled = false,
  hiddenLabel = false,
  isEditing,
  cin7Category,
  shopifyCategory,
  required,
  error,
  helperText,
}) => {
  const { getToken } = useContext(AuthContext);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);

        const res = await fetchWithInterceptor("/api/cin7/categories", {
          headers: {
            "x-access-token": getToken(),
          },
        });

        if (!res.ok) return;

        const data = await res.json();

        setCategories(
          data.map((c) => ({
            label: c.Name,
            value: c.Name,
          }))
        );
      } catch (err) {
        console.error("Error fetching categories", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [getToken]);

  const selectedOption = categories.find((c) => c.value === value) || null;

  const renderInputAdornment = () => {
    if (cin7Category && shopifyCategory) {
      return renderInputMatchAdornment(
        isEditing,
        cin7Category,
        shopifyCategory
      );
    }
    return null;
  };

  return (
    <Autocomplete
      fullWidth
      options={categories}
      value={selectedOption}
      loading={loading}
      disabled={disabled}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      getOptionLabel={(option) => option.label}
      onChange={(_, newValue) => onChange(newValue?.value || "")}
      renderInput={(params) => (
        <TextField
          {...params}
          hiddenLabel={hiddenLabel}
          label={hiddenLabel ? "" : "Category"}
          size="small"
          fullWidth
          required={required}
          error={error}
          helperText={helperText}
          slotProps={{
            input: {
              ...params.InputProps,
              ...renderInputAdornment(),
            },
          }}
        />
      )}
    />
  );
};

export default CategorySelector;
